import { TemplateConfig } from '../Templar/RenderPdfPrescription';
import { PUSH_RENDER_PDF_TEMPLATE_CONFIG } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type Res = { success: boolean; error?: string };

export type Response = { status: string; error: string };

export type TemplateV2 = TemplateConfig;

export default async (docid: string, config: TemplateV2): Promise<Res> => {
    config.__v2 = true; // Ensure the config is marked as v2
    return fetchWithRefresh(PUSH_RENDER_PDF_TEMPLATE_CONFIG(docid), {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
        },
        body: JSON.stringify(config),
    }).then(async (res) => {
        const data: Response = await res.json();
        if (res.status === 200) {
            return { success: true };
        } else {
            throw new Error(data.error);
        }
    });
};
